import VueAnalytics from 'vue-analytics';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App';
import router from './router';
import storeConfig from './store';
import './components';

import './main.css';

import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';

import config from '@/config';
import affiliates from './util/affiliates';

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
  dsn:
    'https://2a58866015a84579b1ca410c32d5553d@o416019.ingest.sentry.io/5309941',
  integrations: [
    new VueIntegration({ Vue, attachProps: true }),
  ],
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'The password is invalid or the user does not have a password.',
  ],
});

Vue.config.productionTip =
  process.env.NODE_ENV === 'production';
Vue.use(Element, { locale });
Vue.use(Vuex);
Vue.use(VueAnalytics, {
  id: config.GOOGLE_ANALYTICS_KEY,
  router,
});
const store = new Vuex.Store(storeConfig);
sync(store, router);

affiliates.save(document.location.search);
firebase.initializeApp(config.FIREBASE_CONFIG);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
